import AoneService from "../axiosbase";
//get shortaddress
export const getShortAddress = async (params,params2) => {
    try  {
        return await AoneService.get(`addresses/api/v1/short-address/mapping/${params}${params2}`)
    } catch (error) {
        return error;
    }
}
//get short address by id
export const getShortAddressbyId = async (params,params2) => {
   try  {
       return await AoneService.get(`addresses/api/v1/short-address/mapping/${params}/${params2}`)
   } catch (error) {
       return error;
   }
}
//edit short address
export const editShortAddressbyId = async (params,params2,data) => {
   try  {
       return await AoneService.put(`addresses/api/v1/short-address/mapping/${params}/${params2}`,data)
   } catch (error) {
       return error;
   }
}
//delete short address
export const deleteShortAddressbyId = async (params,params2) => {
   try  {
       return await AoneService.delete(`addresses/api/v1/short-address/mapping/${params}/${params2}`)
   } catch (error) {
       return error;
   }
}

//post short address
export const importShortAddress = async (params,data) => {
   try {
     return await AoneService.post(`addresses/api/v1/short-address/mapping/${params}/upload`, data, {
       "Content-Type": "multipart/form-data",
     });
   } catch (error) {
     return error;
   }
 };
  //export short address
  export const exportShortAddress = async (params,params2) => {
   try {
     return await AoneService.get(`addresses/api/v1/short-address/mapping/${params}/export${params2}`, {
       responseType: "blob",
     });
   } catch (error) {
     return error;
   }
 };

  //Short address history
  //get history
  export const getShortAddressHistory = async (params,params2) => {
   try  {
       return await AoneService.get(`addresses/api/v1/short-address/history/${params}/history${params2}`)
   } catch (error) {
       return error;
   }
}
//get history by national address
export const getShortAddressHistorybyNational = async (params,params2,params3) => {
   try  {
       return await AoneService.get(`addresses/api/v1/short-address/history/${params}/history/${params2}${params3}`)
   } catch (error) {
       return error;
   }
}
//get history by geolocation
export const getShortAddressHistorybyGeoLocation = async (params,params2) => {
   try  {
       return await AoneService.get(`addresses/api/v1/short-address/history/${params}/history/${params2}/geo-location`)
   } catch (error) {
       return error;
   }
}
//export history
export const exportShortAddressHistory = async (params,params2) => {
   try {
     return await AoneService.get(`addresses/api/v1/short-address/history/${params}/history/export${params2}`, {
       responseType: "blob",
     });
   } catch (error) {
     return error;
   }
 };

 const getQueryStringParams = (paginationParams, sortingParams, filterParams) => {
    const { code } = filterParams || {};
    const { sortBy } = sortingParams || {};
    const { pageNo, pageSize } = paginationParams || {};

    let queryStringParams = `?page=${pageNo}&size=${pageSize}&sortBy=${sortBy}`;

    queryStringParams += `&shortAddress=${encodeURIComponent(code?.trim() ?? "")}`;

    return queryStringParams;
};

export const getBlacklistCodesService = async (paginationParams, sortingParams, filterParams) => {
    const queryStringParams = getQueryStringParams(paginationParams, sortingParams, filterParams);

    try {
        return await AoneService.get(`addresses/api/v1/short-address/black-list/${queryStringParams}`);
    } catch (error) {
        return error;
    }
};

export const addBlacklistCodeService = async (data) => {
  try {
    return await AoneService.post("addresses/api/v1/short-address/black-list/", data);
  } catch (error) {
    return error;
  }
};

export const deleteBlacklistCodeService = async (code) => {
  try {
    return await AoneService.delete(`addresses/api/v1/short-address/black-list/${code}`);
  } catch (error) {
    return error;
  }
};

export const downloadBlacklistCodeService = async (paginationParams, sortingParams, filterParams) => {
  const queryStringParams = getQueryStringParams(paginationParams, sortingParams, filterParams);

  try {
    return await AoneService.get(`addresses/api/v1/short-address/black-list/export${queryStringParams}`, { responseType: "blob" });
  } catch (error) {
    return error;
  }
};

export const downloadBlacklistTemplateService = async () => {
  try {
    return await AoneService.get("addresses/api/v1/short-address/black-list/template/download", { responseType: "blob" });
  } catch (error) {
    return error;
  }
};

export const uploadBlacklistCodeService = async (formData) => {
  try {
    return await AoneService.post("addresses/api/v1/short-address/black-list/import", formData);
  } catch (error) {
    return error;
  }
};